import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import useAlert from 'hooks/useAlert';
import useModalRouter from 'hooks/useModalRouter';

import { BLACKLISTED_CUSTOMER } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS from 'utils/paths';

import { faPlus } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author @omerrkosar
 */

const BlacklistedCustomerList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	const { showWarning } = useAlert();
	const navigate = useNavigate();

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.string, width: 100, show: false },
			{ Header: 'customerName', accessor: 'customerName', width: 130, filterType: FilterType.string },
			{ Header: 'phoneNumber', accessor: 'phoneNumber', width: 100, filterType: FilterType.string },
			{ Header: 'blockedOrderCount', accessor: 'blockedOrderCount', filterType: FilterType.number, width: 200 }
		],
		[]
	);
	const { showModal } = useModalRouter();

	const blacklistCorrector = useSelector((state) => state.user.generalSettings.dataCorrectorBlacklist);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/blacklistedCustomer-icon.json.gz"
				title="blacklistedCustomer">
				<Authorization path="/modal/blacklisted-customer-form">
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						className="addButton"
						icon={faPlus}
						label="addBlacklistedCustomer"
						onClick={() => {
							showModal('blacklisted-customer-form');
							!blacklistCorrector &&
								showWarning({
									header: 'blacklistCorrectorError.header',
									message: 'blacklistCorrectorError.message',
									link: 'goToAutocorrectorSettings',
									linkAction: () => {
										navigate(PATHS.AUTOCORRECTOR);
									}
								});
						}}
						variant="blue"
					/>
				</Authorization>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.BLACKLISTED_CUSTOMER_LIST}
				columns={columns}
				fetchUrl={BLACKLISTED_CUSTOMER.GET_BLACKLISTED_CUSTOMER_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="blacklistedCustomer"
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default BlacklistedCustomerList;
